import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['item'];
  static values = {
    hiddenClass: { type: String, default: 'tw-hidden' },
  };

  connect() {
    this.element.addEventListener('mouseleave', this.hide.bind(this));
  }

  disconnect() {
    this.element.removeEventListener('mouseleave', this.hide.bind(this));
  }

  show() {
    this.itemTargets.forEach((item) => {
      if (item.classList.contains(this.hiddenClassValue)) {
        item.classList.remove(this.hiddenClassValue);
      }
    });
  }

  hide() {
    this.itemTargets.forEach((item) => {
      if (!item.classList.contains(this.hiddenClassValue)) {
        item.classList.add(this.hiddenClassValue);
      }
    });
  }
}
